import React from 'react';


export default class Loading extends React.Component{
    render(){
        const {loadingText, percent } = this.props;
        if((100 - percent) <= 5){
            return (
                <div><i className="far fa-check-circle text-success"></i> Complete!</div>
            );
        }
        return (
            <div>
                {loadingText}
                <div className="progress my-2">
                    <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100" style={{width: percent + '%'}}></div>
                </div>
            </div>
        )
    }
}